import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Avatar from 'antd/es/avatar';
import Comment from 'antd/es/comment';
import Row from 'antd/lib/grid/row';
import Col from 'antd/lib/grid/col';
import {CommentEditorForm, CommentsList} from '../index';
import {
  getCommentsData,
  getMoreCommentsData,
  setCommentCount,
} from '../../redux/actions/Comments';
import {
  getCommentDataReselector,
  getUserData,
} from '../../redux/selectors/selectors';
import {getAvatarUrl} from '../../helpers/util';
import './Comments.css';

const Comments = props => {

  const userData = useSelector(getUserData);
  const comments = useSelector(getCommentDataReselector);
  const dispatch = useDispatch();

  const {postId, productType, count} = props;

  useEffect(() => {
    dispatch(getCommentsData(postId, productType));
    dispatch(setCommentCount(count));
  }, []);

  useEffect(() => {
    dispatch(getCommentsData(postId, productType));
    dispatch(setCommentCount(count));
  }, [postId, productType, count]);

  const {name, avatarUrl} = userData;
  const {hasNextPage} = comments.commentsData.pageInfo;

  const getMoreComments = () => {
    dispatch(getMoreCommentsData());
  };

  return (
      <Row>
        <Col span={24}>
          <div className="comments-section">
            <CommentsList/>
            {
              hasNextPage && (
                  <Row>
                    <Col span={24} className="text-center mc-mtb-20">
                      <span onClick={getMoreComments} className="load-more">Load more</span>
                    </Col>
                  </Row>
              )
            }
            <Comment
                avatar={
                  <Avatar
                      src={getAvatarUrl(avatarUrl)}
                      alt={name}
                  />
                }
                content={<CommentEditorForm/>}
            />
          </div>
        </Col>
      </Row>
  );
};

export {Comments};
